

// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { groupsAPI, campaignsAPI, messagesAPI } from '../utils/api';
// import { useAuth } from '../context/AuthContext';
// import { useSocket } from '../context/SocketContext';
// import CreateGroupModal from './Groups/CreateGroupModal';
// import toast from 'react-hot-toast';
// import { format, isToday, isYesterday } from 'date-fns';

// function getInitials(name = '') {
//   return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
// }

// function formatTime(dateStr) {
//   if (!dateStr) return '';
//   const d = new Date(dateStr);
//   if (isToday(d)) return format(d, 'HH:mm');
//   if (isYesterday(d)) return 'Yesterday';
//   return format(d, 'MMM d');
// }

// const AVATAR_COLORS = ['#4f7dff','#a855f7','#22c55e','#f59e0b','#ef4444','#06b6d4'];
// function avatarColor(name = '') {
//   let hash = 0;
//   for (let c of name) hash = c.charCodeAt(0) + ((hash << 5) - hash);
//   return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
// }

// export default function Sidebar({ selectedGroupId, onSelectGroup }) {
//   const { user, logout } = useAuth();
//   const { on, connected, joinGroup, leaveGroup } = useSocket();
//   const [groups, setGroups] = useState([]);
//   const [threads, setThreads] = useState([]);
//   const [search, setSearch] = useState('');
//   const [expandedThreads, setExpandedThreads] = useState({});
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [pinnedGroups, setPinnedGroups] = useState([]);
//   const [unreadCounts, setUnreadCounts] = useState({});
//   const [groupLastUnreadTime, setGroupLastUnreadTime] = useState({});

//   // FIX 1: Stable position ref — only updated when a NEW message arrives,
//   // never when a message is read. This prevents re-ordering on read.
//   const stablePositionRef = useRef({});

//   const isFirstRender = useRef(true);

//   const loadGroups = useCallback(async () => {
//     try {
//       const data = await groupsAPI.getAll();
//       setGroups(data.groups || []);
//       setThreads(data.threads || []);

//       if (data.groups && data.groups.length > 0) {
//         data.groups.forEach(group => {
//           if (group.id) joinGroup(group.id);
//         });
//       }

//       loadUnreadCounts();
//     } catch (error) {
//       toast.error('Failed to load groups');
//     } finally {
//       setLoading(false);
//     }
//   }, [joinGroup]);

//   // FIX 2: loadUnreadCounts now detects count INCREASES (new message)
//   // vs decreases (read). Only increases update stablePositionRef.
//   const loadUnreadCounts = useCallback(async () => {
//     try {
//       const data = await messagesAPI.getUnreadCounts();
//       const newUnreadCounts = data.unreadCounts || {};

//       setUnreadCounts(prev => {
//         Object.keys(newUnreadCounts).forEach(groupId => {
//           const prevCount = prev[groupId] || 0;
//           const newCount = newUnreadCounts[groupId] || 0;
//           // Only stamp if count went UP — a new message arrived
//           if (newCount > prevCount) {
//             stablePositionRef.current[groupId] = Date.now();
//           }
//           // Reading (count goes down) does NOT update stablePositionRef
//         });
//         return newUnreadCounts;
//       });

//       setGroupLastUnreadTime(prev => {
//         const updated = { ...prev };
//         Object.keys(newUnreadCounts).forEach(groupId => {
//           if (newUnreadCounts[groupId] > 0) {
//             updated[groupId] = Date.now();
//           }
//         });
//         return updated;
//       });
//     } catch (error) {
//       console.error('Failed to load unread counts:', error);
//     }
//   }, []);

//   const markGroupAsRead = useCallback(async (groupId) => {
//     try {
//       await messagesAPI.getMessages(groupId);
//       // Only clear unread count locally — do NOT touch stablePositionRef here
//       setUnreadCounts(prev => ({ ...prev, [groupId]: 0 }));
//       await loadUnreadCounts();
//     } catch (error) {
//       console.error('Failed to mark group as read:', error);
//     }
//   }, []);

//   const handleGroupSelect = useCallback((group) => {
//     onSelectGroup(group);
//     if (group && group.id) markGroupAsRead(group.id);
//   }, [onSelectGroup, markGroupAsRead]);

//   useEffect(() => {
//     const storageKey = `pinned_groups_${user?.id}`;
//     const saved = localStorage.getItem(storageKey);
//     if (saved) {
//       try { setPinnedGroups(JSON.parse(saved)); } catch (e) { console.error(e); }
//     } else {
//       setPinnedGroups([]);
//     }
//   }, [user?.id]);

//   useEffect(() => {
//     if (user?.id && !isFirstRender.current) {
//       localStorage.setItem(`pinned_groups_${user.id}`, JSON.stringify(pinnedGroups));
//     } else if (isFirstRender.current) {
//       isFirstRender.current = false;
//     }
//   }, [pinnedGroups]);

//   const togglePinGroup = useCallback((groupId) => {
//     setPinnedGroups(prev =>
//       prev.includes(groupId) ? prev.filter(id => id !== groupId) : [...prev, groupId]
//     );
//   }, []);

//   const isGroupPinned = useCallback((groupId) => {
//     return pinnedGroups.includes(groupId);
//   }, [pinnedGroups]);

//   useEffect(() => { loadGroups(); }, [loadGroups]);

//   useEffect(() => {
//     const unsub = on('new_message', (msg) => {
//       console.log('📩 NEW MESSAGE RECEIVED', msg);
//       // FIX 3: Stamp stablePositionRef FIRST, before setGroups or loadGroups.
//       // This ensures by the time the sort re-runs, the ref has the correct
//       // timestamp and the fallback to last_message_at is never used.
//       if (msg?.group_id) {
//         stablePositionRef.current[msg.group_id] = Date.now();
//       }

//       // Update group's last_message_at in local state (no API call needed)
//       setGroups(prev => prev.map(g =>
//         g.id === msg.group_id ? { ...g, last_message_at: msg.sent_at } : g
//       ));

//       // FIX 4: Removed loadGroups() call here.
//       // loadGroups() was fetching backend data which returns ORDER BY last_message_at DESC,
//       // which overwrote the frontend state and bypassed stablePositionRef entirely.
//       // The local setGroups above is enough to keep last_message_at current.

//       // Update unread count for recipient only
//       // if (
//       //   msg.group_id &&
//       //   msg.sender_id !== user?.id &&
//       //   (msg.recipient_id === user?.id || msg.secondary_recipient_id === user?.id)
//       // ) {
//       //   setUnreadCounts(prev => ({
//       //     ...prev,
//       //     [msg.group_id]: (prev[msg.group_id] || 0) + 1
//       //   }));
//       // }
//       if (
//   msg.group_id &&
//   msg.sender_id !== user?.id &&
//   !msg.is_task && // ✅ IGNORE TASK MESSAGES
//   (
//     msg.recipient_id === user?.id ||
//     msg.secondary_recipient_id === user?.id
//   )
// ) {
//   setUnreadCounts(prev => ({
//     ...prev,
//     [msg.group_id]: (prev[msg.group_id] || 0) + 1
//   }));
// }
//     });

// //     const unsubTaskAssigned = on('task_assigned', (data) => {
// //   console.log('[SOCKET task_assigned RECEIVED]', data);

// //   // const { task, group_id, assigned_to } = data;
// //   const { group_id, recipient_id } = data;

// // if (Number(recipient_id) !== Number(user?.id)) return;

// //   // ✅ 1. PERSONALIZATION (IMPORTANT)
// //   if (Number(assigned_to) !== Number(user?.id)) {
// //     console.log('❌ Task not for this user, ignoring');
// //     return;
// //   }

// //   // ✅ 2. FIX WRONG GROUP ISSUE
// //   if (group_id) {
// //     stablePositionRef.current[group_id] = Date.now();
// //   }

// //   // ✅ 3. UPDATE GROUP LAST ACTIVITY
// //   setGroups(prev =>
// //     prev.map(g =>
// //       g.id === group_id
// //         ? { ...g, last_message_at: new Date().toISOString() }
// //         : g
// //     )
// //   );

// //   // ✅ 4. INCREASE UNREAD COUNT
// //   setUnreadCounts(prev => ({
// //     ...prev,
// //     [group_id]: (prev[group_id] || 0) + 1
// //   }));
// // });
// //add

// // const unsubTaskAssigned = on('task_assigned', (data) => {
// //   const { group_id } = data;

// //   if (!group_id) return;

// //   stablePositionRef.current[group_id] = Date.now();

// //   setGroups(prev =>
// //     prev.map(g =>
// //       g.id === group_id
// //         ? { ...g, last_message_at: new Date().toISOString() }
// //         : g
// //     )
// //   );

// //   setUnreadCounts(prev => ({
// //     ...prev,
// //     [group_id]: (prev[group_id] || 0) + 1
// //   }));
// // });

// const unsubTaskAssigned = on('task_assigned', (data) => {
//   const { group_id, recipient_id } = data;

//   // ✅ IMPORTANT: only update for correct user
//   if (Number(recipient_id) !== Number(user?.id)) return;

//   if (!group_id) return;

//   // ✅ move group to top
//   stablePositionRef.current[group_id] = Date.now();

//   // ✅ update last message time
//   setGroups(prev =>
//     prev.map(g =>
//       g.id === group_id
//         ? { ...g, last_message_at: new Date().toISOString() }
//         : g
//     )
//   );

//   // ✅ increase ONLY this user's count
//   setUnreadCounts(prev => ({
//     ...prev,
//     [group_id]: (prev[group_id] || 0) + 1
//   }));
// });

// // const unsubTaskAssigned = on('task_assigned', (data) => {
// //   console.log('[SOCKET task_assigned RECEIVED]', data);

// //   // const { group_id, recipient_id } = data;

// //   // if (Number(recipient_id) !== Number(user?.id)) return;

// //   if (group_id) {
// //     stablePositionRef.current[group_id] = Date.now();
// //   }

// //   setGroups(prev =>
// //     prev.map(g =>
// //       g.id === group_id
// //         ? { ...g, last_message_at: new Date().toISOString() }
// //         : g
// //     )
// //   );

// //   setUnreadCounts(prev => ({
// //     ...prev,
// //     [group_id]: (prev[group_id] || 0) + 1
// //   }));
// // });
// // const unsubTaskUpdate = on('task_update', (data) => {
// //   console.log('[SOCKET task_update RECEIVED]', data);

// //   // const { group_id, updated_by } = data;

// //   // ❌ Ignore if current user updated it
// //   // if (Number(updated_by) === Number(user?.id)) return;
// // const { group_id, recipient_id } = data;

// // if (Number(recipient_id) !== Number(user?.id)) return;
// //   if (group_id) {
// //     stablePositionRef.current[group_id] = Date.now();

// //     setUnreadCounts(prev => ({
// //       ...prev,
// //       [group_id]: (prev[group_id] || 0) + 1
// //     }));
// //   }
// // });
// // const unsubTaskUpdate = on('task_update', (data) => {
// //   console.log('[SOCKET task_update RECEIVED]', data);

// //   // const { group_id, recipient_id } = data;

// //   // if (Number(recipient_id) !== Number(user?.id)) return;

// //   if (group_id) {
// //     stablePositionRef.current[group_id] = Date.now();

// //     setUnreadCounts(prev => ({
// //       ...prev,
// //       [group_id]: (prev[group_id] || 0) + 1
// //     }));
// //   }
// // });
// // const unsubTaskUpdate = on('task_update', (data) => {
// //   const { group_id } = data;

// //   if (!group_id) return;

// //   stablePositionRef.current[group_id] = Date.now();

// //   setUnreadCounts(prev => ({
// //     ...prev,
// //     [group_id]: (prev[group_id] || 0) + 1
// //   }));
// // });
// const unsubTaskUpdate = on('task_update', (data) => {
//   const { group_id, recipient_id } = data;

//   // ✅ filter user
//   if (Number(recipient_id) !== Number(user?.id)) return;

//   if (!group_id) return;

//   stablePositionRef.current[group_id] = Date.now();

//   setUnreadCounts(prev => ({
//     ...prev,
//     [group_id]: (prev[group_id] || 0) + 1
//   }));
// });

//     const unsubGroupCreated = on('group_created', (data) => {
//       console.log("📢 group_created event:", data);
//       if (data.group && data.group.member_ids?.includes(user?.id)) {
//         setGroups(prev => {
//           const existingIndex = prev.findIndex(g => g.id === data.group.id);
//           if (existingIndex >= 0) {
//             return prev.map((g, i) => i === existingIndex ? { ...g, ...data.group } : g);
//           }
//           return [data.group, ...prev];
//         });
//         loadGroups();
//         // loadUnreadCounts();
//       }
//     });

//     const unsubCampaignCreated = on('campaign_created', (data) => {
//       if (data.message) toast.success(data.message);
//       joinGroup(data.campaign.group_id);
//       setGroups(prev => {
//         const exists = prev.find(g => g.id === data.campaign.group_id);
//         if (exists) return prev;
//         return [{
//           id: data.campaign.group_id,
//           group_name: data.campaign.group_name,
//           campaign_name: data.campaign.campaign_name
//         }, ...prev];
//       });
//     });

//     const unsubMemberAdded = on('member_added', (data) => {
//       if (Number(data.user_id) === user?.id) {
//         if (data.group_id) joinGroup(data.group_id);
//         loadGroups();
//         toast.success(`You were added to a group by ${data.added_by_name}`);
//       }
//     });

//     const unsubMemberRemoved = on('member_removed', (data) => {
//       if (Number(data.user_id) === user?.id) {
//         leaveGroup(data.group_id);
//         setGroups(prev => prev.filter(g => g.id !== Number(data.group_id)));
//         toast.success(`You were removed from a group by ${data.removed_by_name}`);
//       }
//     });

//     return () => {
//       unsub();
//       unsubGroupCreated();
//       unsubCampaignCreated();
//       unsubMemberAdded();
//       unsubMemberRemoved();
//       unsubTaskAssigned(); //add
//       unsubTaskUpdate(); //add
//     };
//   }, [on, user?.id, loadGroups, loadUnreadCounts, joinGroup, leaveGroup]);
//   const toggleThread = (key) => {
//     setExpandedThreads(prev => ({ ...prev, [key]: !prev[key] }));
//   };

//   const filteredGroups = search
//     ? groups.filter(g =>
//         g.group_name?.toLowerCase().includes(search.toLowerCase()) ||
//         g.campaign_name?.toLowerCase().includes(search.toLowerCase())
//       )
//     : null;

//   const sortedGroups = filteredGroups || groups;

//   // FIX 5: groupsToRender no longer does its own sort by last_message_at.
//   // Sorting is handled entirely by getUnifiedSortedItems using stableSortTime.
//   const groupsToRender = sortedGroups ? [...sortedGroups] : sortedGroups;

//   const validThreads = threads.filter(thread => (thread.groups || []).length > 1);
//   const threadGroupIds = new Set(validThreads.flatMap(t => t.groups.map(g => g.id)));

//   // FIX 6: Unified sort — groups and threads treated identically.
//   // Both use stableSortTime so:
//   //   - New message → stablePositionRef stamped → item moves to top
//   //   - Read message → stablePositionRef unchanged → item stays in place
//   const getUnifiedSortedItems = useCallback(() => {
//     if (search) {
//       return groupsToRender.map(group => ({
//         type: 'group',
//         item: group,
//         priority: 0,
//         unreadCount: unreadCounts[group.id] || 0,
//         lastMessageAt: new Date(group.last_message_at || 0),
//         isPinned: isGroupPinned(group.id)
//       }));
//     }

//     const allItems = [];

//     // Pinned groups
//     // const pinnedGroupItems = groups
//     //   .filter(g => pinnedGroups.includes(g.id))
//     //   .map(group => ({
//     //     type: 'group',
//     //     item: group,
//     //     priority: 1,
//     //     unreadCount: unreadCounts[group.id] || 0,
//     //     lastMessageAt: new Date(group.last_message_at || 0),
//     //     stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
//     //     isPinned: true
//     //   }));

//     const pinnedGroupItems = pinnedGroups
//   .map(id => groups.find(g => g.id === id))
//   .filter(Boolean)
//   .map(group => ({
//     type: 'group',
//     item: group,
//     priority: 1,
//     unreadCount: unreadCounts[group.id] || 0,
//     lastMessageAt: new Date(group.last_message_at || 0),
//     stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
//     isPinned: true
//   }));
//     // Threads — same logic as groups, no priority difference
//     const threadItems = threads
//       .filter(thread => (thread.groups || []).length > 1)
//       .map(thread => {
//         const threadGroups = thread.groups || [];
//         const totalUnreadCount = threadGroups.reduce((sum, group) =>
//           sum + (unreadCounts[group.id] || 0), 0
//         );
//         const latestMessageAt = threadGroups.reduce((latest, group) => {
//           const groupTime = new Date(group.last_message_at || 0);
//           return groupTime > latest ? groupTime : latest;
//         }, new Date(0));
//         // Use the most recent stableSortTime across all groups in this thread
//         const threadStableTime = threadGroups.reduce((latest, group) => {
//           const t = stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime();
//           return t > latest ? t : latest;
//         }, 0);
//         return {
//           type: 'thread',
//           item: thread,
//           priority: 0,  // Same priority as groups — no bias
//           unreadCount: totalUnreadCount,
//           lastMessageAt: latestMessageAt,
//           stableSortTime: threadStableTime,
//           isPinned: false,
//           groups: threadGroups
//         };
//       });

//     // Unpinned groups not in threads
//     const unpinnedGroupItems = groups
//       .filter(g => !pinnedGroups.includes(g.id) && !threadGroupIds.has(g.id))
//       .map(group => ({
//         type: 'group',
//         item: group,
//         priority: 0,
//         unreadCount: unreadCounts[group.id] || 0,
//         lastMessageAt: new Date(group.last_message_at || 0),
//         stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
//         isPinned: false
//       }));

//     allItems.push(...pinnedGroupItems, ...threadItems, ...unpinnedGroupItems);

//     return allItems.sort((a, b) => {
//       // 1. Pinned first
//       if (a.isPinned && !b.isPinned) return -1;
//       if (!a.isPinned && b.isPinned) return 1;

//   // 2. If BOTH are pinned → KEEP ORIGINAL ORDER (do NOT sort)
//   if (a.isPinned && b.isPinned) return 0;

//       // 2. Unread before read
//       // const aHasUnread = a.unreadCount > 0;
//       // const bHasUnread = b.unreadCount > 0;
//       // if (aHasUnread && !bHasUnread) return -1;
//       // if (!aHasUnread && bHasUnread) return 1;

//       // 3. stableSortTime — position freezes on read, moves only on new message
//       return b.stableSortTime - a.stableSortTime;
//     });
//   }, [search, groupsToRender, groups, threads, pinnedGroups, unreadCounts, threadGroupIds, isGroupPinned]);

//   const renderUnifiedItem = (itemData) => {
//     const { type, item, unreadCount } = itemData;

//     if (type === 'thread') {
//       const threadName = (() => {
//         const firstGroup = item.groups?.[0];
//         if (firstGroup?.crm_campaign_data) {
//           try {
//             const crmData = typeof firstGroup.crm_campaign_data === 'string'
//               ? JSON.parse(firstGroup.crm_campaign_data)
//               : firstGroup.crm_campaign_data;
//             if (crmData?.campaign_name) return crmData.campaign_name;
//           } catch {}
//         }
//         return item.package_id.replace(/^com\./, '');
//       })();

//       return (
//         <div key={item.package_id}>
//           <div
//             className="group-item"
//             onClick={() => toggleThread(item.package_id)}
//             style={{ cursor: 'pointer', background: 'var(--bg-secondary)' }}
//           >
//             <div
//               className="group-avatar"
//               style={{
//                 background: `${avatarColor(threadName)}22`,
//                 color: avatarColor(threadName),
//                 border: `1px solid ${avatarColor(threadName)}44`
//               }}
//             >
//               {getInitials(threadName)}
//             </div>
//             <div className="group-info">
//               <div className="group-name">{threadName}</div>
//               <div className="group-meta">
//                 <span>{item.groups.length} campaigns</span>
//               </div>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
//               {unreadCount > 0 && (
//                 <span className="group-badge" style={{ background: 'var(--accent)' }}>
//                   {unreadCount}
//                 </span>
//               )}
//               <span style={{ fontSize: 12 }}>
//                 {expandedThreads[item.package_id] ? '▲' : '▼'}
//               </span>
//             </div>
//           </div>
//           {expandedThreads[item.package_id] && item.groups.map(group => renderGroup(group, true))}
//         </div>
//       );
//     }

//     return renderGroup(item, false);
//   };

//   const renderGroup = (group, isThreadGroup = false) => (
//     <div
//       key={group.id}
//       className={`group-item ${selectedGroupId === group.id ? 'active' : ''}`}
//       onClick={() => handleGroupSelect(group)}
//     >
//       <div
//         className={`group-avatar ${group.group_type}`}
//         style={{
//           background: `${avatarColor(group.group_name)}22`,
//           color: avatarColor(group.group_name),
//           border: `1px solid ${avatarColor(group.group_name)}44`
//         }}
//       >
//         {getInitials(group.group_name)}
//       </div>
//       <div className="group-info">
//         <div className="group-name">{group.group_name}</div>
//         <div className="group-meta">
//           {group.campaign_status && (
//             <span className={`badge badge-${group.campaign_status === 'active' ? 'live' : 'paused'}`} style={{ marginRight: 4 }}>
//               {group.campaign_status}
//             </span>
//           )}
//           {group.geo && <span>{group.geo.split(',')[0]} · </span>}
//           {group.payout && <span>${group.payout}</span>}
//         </div>
//       </div>
//       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
//         <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>{formatTime(group.last_message_at)}</span>
//         {(unreadCounts[group.id] || 0) > 0 && (
//           <span className="group-badge" style={{ background: 'var(--accent)' }}>
//             {unreadCounts[group.id]}
//           </span>
//         )}
//         <button
//           className={`btn-icon ${isGroupPinned(group.id) ? 'pinned' : ''}`}
//           onClick={(e) => { e.stopPropagation(); togglePinGroup(group.id); }}
//           style={{
//             fontSize: 10,
//             padding: 2,
//             opacity: isGroupPinned(group.id) ? 1 : 0.5,
//             color: isGroupPinned(group.id) ? 'var(--warning)' : 'var(--text-muted)'
//           }}
//           title={isGroupPinned(group.id) ? 'Unpin group' : 'Pin group'}
//         >
//           📌
//         </button>
//       </div>
//     </div>
//   );

//   return (
//     <div className="sidebar">
//       <div style={{fontSize:10, background:'#111', color:'#0f0', padding:6}}>
//   <div>UnreadCounts: {JSON.stringify(unreadCounts)}</div>
//   <div>StableRef: {JSON.stringify(stablePositionRef.current)}</div>
// </div>
//       <div className="sidebar-header">
//         <div className="sidebar-title">
//           <span>💬</span>
//           <span>CRM Chat</span>
//           <span style={{ marginLeft: 4 }} className={`status-dot ${connected ? 'online' : 'offline'}`} />
//         </div>
//         <div style={{ display: 'flex', gap: 4 }}>
//           {(user?.role === 'admin' || user?.role === 'advertiser_manager' || user?.role === 'advertiser') && (
//             <button className="btn-icon tooltip" onClick={() => setShowCreateModal(true)} title="New Group">
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
//               </svg>
//               <span className="tooltip-text">New Group</span>
//             </button>
//           )}
//           <button className="btn-icon tooltip" onClick={logout}>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
//             </svg>
//             <span className="tooltip-text">Logout</span>
//           </button>
//         </div>
//       </div>

//       <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
//         <div style={{ width: 32, height: 32, borderRadius: '50%', background: `${avatarColor(user?.full_name)}33`, color: avatarColor(user?.full_name), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>
//           {getInitials(user?.full_name)}
//         </div>
//         <div>
//           <div style={{ fontSize: 13, fontWeight: 600 }}>{user?.full_name}</div>
//           <div style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role}</div>
//         </div>
//         <span className="status-dot online" style={{ marginLeft: 'auto' }} />
//       </div>

//       <div className="sidebar-search">
//         <input
//           type="text"
//           className="search-input"
//           placeholder="Search groups..."
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//         />
//       </div>

//       <div className="sidebar-groups">
//         {loading ? (
//           <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>Loading groups...</div>
//         ) : (
//           <>
//             {getUnifiedSortedItems().length > 0 ? (
//               getUnifiedSortedItems().map(renderUnifiedItem)
//             ) : (
//               <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>
//                 {search ? 'No results' : 'No groups yet. Create one from a campaign.'}
//               </div>
//             )}
//             {!loading && groups.length === 0 && !search && (
//               <div className="empty-state" style={{ padding: 40 }}>
//                 <div className="empty-state-icon">🗂️</div>
//                 <p>No groups yet.<br/>Create one from a campaign.</p>
//                 {(user?.role === 'admin' || user?.role === 'advertiser_manager' || user?.role === 'advertiser') && (
//                   <button className="btn btn-primary btn-sm" onClick={() => setShowCreateModal(true)}>
//                     Create Group
//                   </button>
//                 )}
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {showCreateModal && (
//         <CreateGroupModal
//           onClose={() => setShowCreateModal(false)}
//           onCreated={(group) => {
//             loadGroups();
//             setShowCreateModal(false);
//             onSelectGroup(group);
//             toast.success('Group created!');
//           }}
//         />
//       )}
//     </div>
//   );



import React, { useState, useEffect, useCallback, useRef } from 'react';
import { groupsAPI, campaignsAPI, messagesAPI, tasksAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';
import { useTheme } from '../context/ThemeContext';
import CreateGroupModal from './Groups/CreateGroupModal';
import toast from 'react-hot-toast';
import { format, isToday, isYesterday } from 'date-fns';

function getInitials(name = '') {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
}

function formatTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isToday(d)) return format(d, 'HH:mm');
  if (isYesterday(d)) return 'Yesterday';
  return format(d, 'MMM d');
}

const AVATAR_COLORS = ['#4f7dff','#a855f7','#22c55e','#f59e0b','#ef4444','#06b6d4'];
function avatarColor(name = '') {
  let hash = 0;
  for (let c of name) hash = c.charCodeAt(0) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function Sidebar({ selectedGroupId, onSelectGroup,onUnreadCountsChange }) {
  const { user, logout } = useAuth();
  const { on, connected, joinGroup, leaveGroup } = useSocket();
  const { isDark, toggleTheme } = useTheme();
  const [groups, setGroups] = useState([]);
  const [threads, setThreads] = useState([]);
  const [search, setSearch] = useState('');
  const [expandedThreads, setExpandedThreads] = useState({});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pinnedGroups, setPinnedGroups] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({});
  // Open tasks assigned to me per group — NOT cleared when the group is opened,
  // only drops when the task is completed or rejected.
  const [pendingTaskCounts, setPendingTaskCounts] = useState({});
  const [groupLastUnreadTime, setGroupLastUnreadTime] = useState({});

  // Draft indicator: track which groups have a saved chat draft
  const [draftGroupIds, setDraftGroupIds] = useState(() => new Set());

  // Seed from localStorage whenever user?.id becomes available (e.g. after auth resolves)
  useEffect(() => {
    if (!user?.id) return;
    const prefix = `chat_draft_${user.id}_`;
    setDraftGroupIds(new Set(
      Object.keys(localStorage)
        .filter(k => k.startsWith(prefix))
        .map(k => parseInt(k.replace(prefix, '')))
        .filter(id => !isNaN(id))
    ));
  }, [user?.id]);

  useEffect(() => {
    const handler = (e) => {
      const gId = Number(e.detail?.groupId);
      if (!gId || !user?.id) return;
      const hasDraft = !!localStorage.getItem(`chat_draft_${user.id}_${gId}`);
      setDraftGroupIds(prev => {
        const next = new Set(prev);
        if (hasDraft) next.add(gId);
        else next.delete(gId);
        return next;
      });
    };
    window.addEventListener('chat-draft-changed', handler);
    return () => window.removeEventListener('chat-draft-changed', handler);
  }, [user?.id]);

  // Task draft indicator
  const [taskDraftGroupIds, setTaskDraftGroupIds] = useState(() => new Set());

  useEffect(() => {
    if (!user?.id) return;
    const prefix = `task_draft_${user.id}_`;
    setTaskDraftGroupIds(new Set(
      Object.keys(localStorage)
        .filter(k => k.startsWith(prefix))
        .map(k => parseInt(k.replace(prefix, '')))
        .filter(id => !isNaN(id))
    ));
  }, [user?.id]);

  useEffect(() => {
    const handler = (e) => {
      const gId = Number(e.detail?.groupId);
      if (!gId || !user?.id) return;
      const hasDraft = !!localStorage.getItem(`task_draft_${user.id}_${gId}`);
      setTaskDraftGroupIds(prev => {
        const next = new Set(prev);
        if (hasDraft) next.add(gId);
        else next.delete(gId);
        return next;
      });
    };
    window.addEventListener('task-draft-changed', handler);
    return () => window.removeEventListener('task-draft-changed', handler);
  }, [user?.id]);

  // FIX 1: Stable position ref — only updated when a NEW message arrives,
  // never when a message is read. This prevents re-ordering on read.
  const stablePositionRef = useRef({});
  useEffect(() => {
  const key = `stable_order_${user?.id}`;
  const saved = localStorage.getItem(key);

  if (saved) {
    try {
      stablePositionRef.current = JSON.parse(saved);
    } catch (e) {
      console.error('Failed to parse stable order');
    }
  }
}, [user?.id]);

  const isFirstRender = useRef(true);

  const loadGroups = useCallback(async () => {
    try {
      const data = await groupsAPI.getAll();
      setGroups(prev => {
        const prevById = new Map(prev.map(g => [g.id, g]));
        return (data.groups || []).map(serverGroup => {
          const localGroup = prevById.get(serverGroup.id);
          if (!localGroup) return serverGroup;
          const serverTime = new Date(serverGroup.last_message_at || serverGroup.created_at || 0).getTime();
          const localTime = new Date(localGroup.last_message_at || localGroup.created_at || 0).getTime();
          return localTime > serverTime
            ? { ...serverGroup, last_message_at: localGroup.last_message_at }
            : serverGroup;
        });
      });
      setThreads(data.threads || []);

      // Note: Backend connection handler automatically queries the DB and joins
      // the socket to all rooms of the user's groups on connection startup.
      // Emitting individual join_group socket events for every group is redundant
      // and causes a database connection queue exhaust.
      
      loadUnreadCounts();
    } catch (error) {
      toast.error('Failed to load groups');
    } finally {
      setLoading(false);
    }
  }, [joinGroup]);
const isInitialUnreadLoad = useRef(true);

  // FIX 2: loadUnreadCounts now detects count INCREASES (new message)
  // vs decreases (read). Only increases update stablePositionRef.
  const loadUnreadCounts = useCallback(async () => {
    try {
      const data = await messagesAPI.getUnreadCounts();
      const newUnreadCounts = data.unreadCounts || {};

      setUnreadCounts(prev => {
  Object.keys(newUnreadCounts).forEach(groupId => {
    const prevCount = prev[groupId] || 0;
    const newCount = newUnreadCounts[groupId] || 0;

    // ❌ Skip update on FIRST load after refresh
    if (!isInitialUnreadLoad.current && newCount > prevCount) {
      stablePositionRef.current[groupId] = Date.now();
    }
  });

  return newUnreadCounts;
});

// ✅ Mark initial load done
// isInitialUnreadLoad.current = false;
//       setUnreadCounts(prev => {
//         Object.keys(newUnreadCounts).forEach(groupId => {
//           const prevCount = prev[groupId] || 0;
//           const newCount = newUnreadCounts[groupId] || 0;
//           // Only stamp if count went UP — a new message arrived
//           if (newCount > prevCount) {
//             stablePositionRef.current[groupId] = Date.now();
//           }
//           localStorage.setItem(
//   `stable_order_${user?.id}`,
//   JSON.stringify(stablePositionRef.current)
// );
//           // Reading (count goes down) does NOT update stablePositionRef
//         });
//         return newUnreadCounts;
//       });

      setGroupLastUnreadTime(prev => {
        const updated = { ...prev };
        Object.keys(newUnreadCounts).forEach(groupId => {
          if (newUnreadCounts[groupId] > 0) {
            updated[groupId] = Date.now();
          }
        });
        return updated;
      });
    } catch (error) {
      console.error('Failed to load unread counts:', error);
    }
  }, []);
  const loadPendingTaskCounts = useCallback(async () => {
    try {
      const data = await tasksAPI.getPendingCounts();
      setPendingTaskCounts(data.pendingCounts || {});
    } catch (error) {
      console.error('Failed to load pending task counts:', error);
    }
  }, []);

  useEffect(() => {
    if (!user?.id) return;
    loadPendingTaskCounts();
    const onStatusChanged = () => loadPendingTaskCounts();
    window.addEventListener('task-status-changed', onStatusChanged);
    return () => window.removeEventListener('task-status-changed', onStatusChanged);
  }, [user?.id, loadPendingTaskCounts]);

  useEffect(() => {
  if (onUnreadCountsChange) {
    onUnreadCountsChange(unreadCounts);
  }
}, [unreadCounts, onUnreadCountsChange]);

  const markGroupAsRead = useCallback(async (groupId) => {
    try {
      await messagesAPI.getMessages(groupId);
      // Also mark every unread message in the group as seen, not just the page
      // that just got fetched — otherwise an old message beyond the user's usual
      // scroll depth can never be marked seen and permanently inflates the badge.
      await messagesAPI.markGroupFullyRead(groupId);
      // Only clear unread count locally — do NOT touch stablePositionRef here
      setUnreadCounts(prev => ({ ...prev, [groupId]: 0 }));
      await loadUnreadCounts();
    } catch (error) {
      console.error('Failed to mark group as read:', error);
    }
  }, []);

  const handleGroupSelect = useCallback((group) => {
    onSelectGroup(group);
    if (group && group.id) markGroupAsRead(group.id);
  }, [onSelectGroup, markGroupAsRead]);

  useEffect(() => {
    const storageKey = `pinned_groups_${user?.id}`;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try { setPinnedGroups(JSON.parse(saved)); } catch (e) { console.error(e); }
    } else {
      setPinnedGroups([]);
    }
  }, [user?.id]);

  useEffect(() => {
    if (user?.id && !isFirstRender.current) {
      localStorage.setItem(`pinned_groups_${user.id}`, JSON.stringify(pinnedGroups));
    } else if (isFirstRender.current) {
      isFirstRender.current = false;
    }
  }, [pinnedGroups]);

  const togglePinGroup = useCallback((groupId) => {
    setPinnedGroups(prev =>
      prev.includes(groupId) ? prev.filter(id => id !== groupId) : [...prev, groupId]
    );
  }, []);

  const isGroupPinned = useCallback((groupId) => {
    return pinnedGroups.includes(groupId);
  }, [pinnedGroups]);

  // useEffect(() => { loadGroups(); }, [loadGroups]);
  //old working 
//   useEffect(() => {
//   loadGroups().then(() => {
//     setGroups(prev => [...prev]); // force re-render using stable order
//   });
// }, [loadGroups]);

// useEffect(() => {
//   loadGroups().then(() => {
//     setGroups(prev => {
//       prev.forEach((g) => {
//         if (!stablePositionRef.current[g.id]) {
//           // ✅ Use created_at so newest groups naturally rank highest
//           stablePositionRef.current[g.id] =
//             new Date(g.created_at || g.last_message_at || 0).getTime();
//         }
//       });

//       localStorage.setItem(
//         `stable_order_${user?.id}`,
//         JSON.stringify(stablePositionRef.current)
//       );

//       return [...prev];
//     });
//   });
// }, [loadGroups]);

//new 
// Replace your two loadGroups useEffects with this single one:
useEffect(() => {
  loadGroups().then(() => {
    setGroups(prev => {
      prev.forEach((g) => {
        const serverTime = new Date(g.last_message_at || g.created_at || 0).getTime();
        const storedTime = stablePositionRef.current[g.id] || 0;

        // ✅ Always use whichever is NEWER — server data or stored interaction
        stablePositionRef.current[g.id] = Math.max(serverTime, storedTime);
      });

      localStorage.setItem(
        `stable_order_${user?.id}`,
        JSON.stringify(stablePositionRef.current)
      );

      return [...prev];
    });
  });
}, [loadGroups]);
// useEffect(() => {
//   loadGroups().then(() => {
//     setGroups(prev => {
//       const now = Date.now();

//       prev.forEach((g, index) => {
//         if (!stablePositionRef.current[g.id]) {
//           // Assign initial order ONLY ONCE
//           // stablePositionRef.current[g.id] = now - index;
//           stablePositionRef.current[g.id] =
//   new Date(g.last_message_at || 0).getTime();
//           // stablePositionRef.current[g.id] = Date.now(); // newest gets highest priority
//         }
//       });

//       localStorage.setItem(
//         `stable_order_${user?.id}`,
//         JSON.stringify(stablePositionRef.current)
//       );

//       return [...prev];
//     });
//   });
// }, [loadGroups]);

//old
//   useEffect(() => {
//     const unsub = on('new_message', (msg) => {
//       console.log('📩 NEW MESSAGE RECEIVED', msg);
//       console.log('[NEW_MESSAGE CHECK]', {
//   msg,
//   currentUser: user?.id,
//   condition: msg.recipient_id === user?.id
// });
//       // FIX 3: Stamp stablePositionRef FIRST, before setGroups or loadGroups.
//       // This ensures by the time the sort re-runs, the ref has the correct
//       // timestamp and the fallback to last_message_at is never used.
//       // if (msg?.group_id) {
//       //   stablePositionRef.current[msg.group_id] = Date.now();
//       // }
//       if (msg?.group_id) {
//   const now = Date.now();
//   stablePositionRef.current[msg.group_id] = now;

//   localStorage.setItem(
//     `stable_order_${user?.id}`,
//     JSON.stringify(stablePositionRef.current)
//   );
// }

//       // Update group's last_message_at in local state (no API call needed)
//       setGroups(prev => prev.map(g =>
//         g.id === msg.group_id ? { ...g, last_message_at: msg.sent_at } : g
//       ));

//       // FIX 4: Removed loadGroups() call here.
//       // loadGroups() was fetching backend data which returns ORDER BY last_message_at DESC,
//       // which overwrote the frontend state and bypassed stablePositionRef entirely.
//       // The local setGroups above is enough to keep last_message_at current.

//       // Update unread count for recipient only
//       // if (
//       //   msg.group_id &&
//       //   msg.sender_id !== user?.id &&
//       //   (msg.recipient_id === user?.id || msg.secondary_recipient_id === user?.id)
//       // ) 
// //       if (
// //   msg.group_id &&
// //   msg.sender_id !== user?.id &&
// //   (
// //     msg.recipient_id === user?.id || 
// //     msg.secondary_recipient_id === user?.id ||
// //     msg.message_type === 'task_notification' // ✅ fallback safety
// //   )
// // )
// // AFTER:
// if (
//   msg.group_id &&
//   msg.sender_id !== user?.id &&
//   !msg.is_task && // ✅ skip all task notifications here — handled by task_assigned/task_update
//   (
//     msg.recipient_id === user?.id || 
//     msg.secondary_recipient_id === user?.id
//   )
// )
//       {
//         setUnreadCounts(prev => ({
//           ...prev,
//           [msg.group_id]: (prev[msg.group_id] || 0) + 1
//         }));
//       }
//     });

//     const unsubTaskAssigned = on('task_assigned', (data) => {
//   console.log('[SOCKET task_assigned RECEIVED]', data);

//   const { task, group_id, assigned_to } = data;

//   // ✅ 1. PERSONALIZATION (IMPORTANT)
//   if (Number(assigned_to) !== Number(user?.id)) {
//     console.log('❌ Task not for this user, ignoring');
//     return;
//   }

//   // ✅ 2. FIX WRONG GROUP ISSUE
//   // if (group_id) {
//   //   stablePositionRef.current[group_id] = Date.now();
//   // }
//   if (group_id) {
//   const now = Date.now();
//   stablePositionRef.current[group_id] = now;

//   localStorage.setItem(
//     `stable_order_${user?.id}`,
//     JSON.stringify(stablePositionRef.current)
//   );
// }

//   // ✅ 3. UPDATE GROUP LAST ACTIVITY
//   setGroups(prev =>
//     prev.map(g =>
//       g.id === group_id
//         ? { ...g, last_message_at: new Date().toISOString() }
//         : g
//     )
//   );

//   // ✅ 4. INCREASE UNREAD COUNT
//   setUnreadCounts(prev => ({
//     ...prev,
//     [group_id]: (prev[group_id] || 0) + 1
//   }));
// });
// //add
// const unsubTaskUpdate = on('task_update', (data) => {
//   console.log('[SOCKET task_update RECEIVED]', data);

//   const { group_id, updated_by } = data;

//   // ❌ Ignore if current user updated it
//   if (Number(updated_by) === Number(user?.id)) return;

//   if (group_id) {
//     stablePositionRef.current[group_id] = Date.now();

//     setUnreadCounts(prev => ({
//       ...prev,
//       [group_id]: (prev[group_id] || 0) + 1
//     }));
//       localStorage.setItem(
//     `stable_order_${user?.id}`,
//     JSON.stringify(stablePositionRef.current)
//   );
//   }
// });
// // if (group_id) {
// //   const now = Date.now();
// //   stablePositionRef.current[group_id] = now;

// //   localStorage.setItem(
// //     `stable_order_${user?.id}`,
// //     JSON.stringify(stablePositionRef.current)
// //   );
// // }
//     const unsubGroupCreated = on('group_created', (data) => {
//       console.log("📢 group_created event:", data);
//       if (data.group && data.group.member_ids?.includes(user?.id)) {
//         setGroups(prev => {
//           const existingIndex = prev.findIndex(g => g.id === data.group.id);
//           if (existingIndex >= 0) {
//             return prev.map((g, i) => i === existingIndex ? { ...g, ...data.group } : g);
//           }
//           return [data.group, ...prev];
//         });
//         loadGroups();
//         loadUnreadCounts();
//       }
//     });

//     const unsubCampaignCreated = on('campaign_created', (data) => {
//       if (data.message) toast.success(data.message);
//       joinGroup(data.campaign.group_id);
//       setGroups(prev => {
//         const exists = prev.find(g => g.id === data.campaign.group_id);
//         if (exists) return prev;
//         return [{
//           id: data.campaign.group_id,
//           group_name: data.campaign.group_name,
//           campaign_name: data.campaign.campaign_name
//         }, ...prev];
//       });
//     });

//     const unsubMemberAdded = on('member_added', (data) => {
//       if (Number(data.user_id) === user?.id) {
//         if (data.group_id) joinGroup(data.group_id);
//         loadGroups();
//         toast.success(`You were added to a group by ${data.added_by_name}`);
//       }
//     });

//     const unsubMemberRemoved = on('member_removed', (data) => {
//       if (Number(data.user_id) === user?.id) {
//         leaveGroup(data.group_id);
//         setGroups(prev => prev.filter(g => g.id !== Number(data.group_id)));
//         toast.success(`You were removed from a group by ${data.removed_by_name}`);
//       }
//     });

//     return () => {
//       unsub();
//       unsubGroupCreated();
//       unsubCampaignCreated();
//       unsubMemberAdded();
//       unsubMemberRemoved();
//       unsubTaskAssigned(); //add
//       unsubTaskUpdate(); //add
//     };
//   }, [on, user?.id, loadGroups, loadUnreadCounts, joinGroup, leaveGroup]);




//new
useEffect(() => {
  const unsub = on('new_message', (msg) => {
    console.log('📩 NEW MESSAGE RECEIVED', msg);

    const isForMe =
      msg.sender_id !== user?.id &&
      (
        msg.is_broadcast ||
        msg.recipient_id === user?.id ||
        msg.secondary_recipient_id === user?.id ||
        (Array.isArray(msg.recipient_ids) && msg.recipient_ids.includes(user?.id))
      );

    console.log('[NEW_MESSAGE CHECK]', {
      msg,
      currentUser: user?.id,
      condition: isForMe
    });

    // 🔥 Update stable position
    if (msg?.group_id) {
      const now = Date.now();
      stablePositionRef.current[Number(msg.group_id)] = now;

      localStorage.setItem(
        `stable_order_${user?.id}`,
        JSON.stringify(stablePositionRef.current)
      );
    }

    // 🔥 Update group last message AND move it to the top of the list
    setGroups(prev => {
      const gid = Number(msg.group_id);
      const idx = prev.findIndex(g => g.id === gid);
      if (idx < 0) return prev;
      const updated = prev.map(g =>
        g.id === gid ? { ...g, last_message_at: msg.sent_at || new Date().toISOString() } : g
      );
      // Move to front so the sort always sees it first
      const [moved] = updated.splice(idx, 1);
      return [moved, ...updated];
    });

    // 🔥 FIXED CONDITION (MAIN FIX)
    if (
      msg.group_id &&
      isForMe &&
      !msg.is_task
    ) {
      setUnreadCounts(prev => ({
        ...prev,
        [msg.group_id]: (prev[msg.group_id] || 0) + 1
      }));
    }
  });

  const unsubTaskAssigned = on('task_assigned', (data) => {
    console.log('[SOCKET task_assigned RECEIVED]', data);
    loadPendingTaskCounts();

    const { group_id, assigned_to } = data;

    if (Number(assigned_to) !== Number(user?.id)) return;

    if (group_id) {
      const now = Date.now();
      stablePositionRef.current[group_id] = now;

      localStorage.setItem(
        `stable_order_${user?.id}`,
        JSON.stringify(stablePositionRef.current)
      );
    }

    setGroups(prev => {
      const gid = Number(group_id);
      const idx = prev.findIndex(g => g.id === gid);
      if (idx < 0) return prev;
      const updated = prev.map(g =>
        g.id === gid ? { ...g, last_message_at: new Date().toISOString() } : g
      );
      const [moved] = updated.splice(idx, 1);
      return [moved, ...updated];
    });

    setUnreadCounts(prev => ({
      ...prev,
      [group_id]: (prev[group_id] || 0) + 1
    }));
  });

  const unsubTaskUpdate = on('task_update', (data) => {
    console.log('[SOCKET task_update RECEIVED]', data);
    loadPendingTaskCounts();

    const { group_id, updated_by } = data;

    if (Number(updated_by) === Number(user?.id)) return;

    if (group_id) {
      stablePositionRef.current[group_id] = Date.now();

      setUnreadCounts(prev => ({
        ...prev,
        [group_id]: (prev[group_id] || 0) + 1
      }));

      localStorage.setItem(
        `stable_order_${user?.id}`,
        JSON.stringify(stablePositionRef.current)
      );
    }
  });

  // const unsubGroupCreated = on('group_created', (data) => {
  //   console.log("📢 group_created event:", data);

  //   if (data.group && data.group.member_ids?.includes(user?.id)) {
  //     setGroups(prev => {
  //       const existingIndex = prev.findIndex(g => g.id === data.group.id);
  //       if (existingIndex >= 0) {
  //         return prev.map((g, i) =>
  //           i === existingIndex ? { ...g, ...data.group } : g
  //         );
  //       }
  //       return [data.group, ...prev];
  //     });

  //     loadGroups();
  //     loadUnreadCounts();
  //   }
  // });
const unsubGroupCreated = on('group_created', (data) => {
  if (data.group && data.group.member_ids?.includes(user?.id)) {
    // ✅ Stamp immediately so it sorts above older groups
    if (data.group.id) {
      stablePositionRef.current[data.group.id] = Date.now();
      localStorage.setItem(
        `stable_order_${user?.id}`,
        JSON.stringify(stablePositionRef.current)
      );
    }

    setGroups(prev => {
      const existingIndex = prev.findIndex(g => g.id === data.group.id);
      if (existingIndex >= 0) {
        return prev.map((g, i) => i === existingIndex ? { ...g, ...data.group } : g);
      }
      return [data.group, ...prev];
    });

    loadGroups();
    loadUnreadCounts();
  }
});

  const unsubCampaignCreated = on('campaign_created', (data) => {
    if (data.message) toast.success(data.message);

    joinGroup(data.campaign.group_id);

    setGroups(prev => {
      const exists = prev.find(g => g.id === data.campaign.group_id);
      if (exists) return prev;

      return [{
        id: data.campaign.group_id,
        group_name: data.campaign.group_name,
        campaign_name: data.campaign.campaign_name
      }, ...prev];
    });
  });

  const unsubMemberAdded = on('member_added', (data) => {
    if (Number(data.user_id) === user?.id) {
      if (data.group_id) joinGroup(data.group_id);
      loadGroups();
      toast.success(`You were added to a group by ${data.added_by_name}`);
    }
  });

  const unsubMemberRemoved = on('member_removed', (data) => {
    if (Number(data.user_id) === user?.id) {
      leaveGroup(data.group_id);
      setGroups(prev => prev.filter(g => g.id !== Number(data.group_id)));
      toast.success(`You were removed from a group by ${data.removed_by_name}`);
    }
  });

  return () => {
    unsub();
    unsubGroupCreated();
    unsubCampaignCreated();
    unsubMemberAdded();
    unsubMemberRemoved();
    unsubTaskAssigned();
    unsubTaskUpdate();
  };

}, [on, user?.id, loadGroups, loadUnreadCounts, loadPendingTaskCounts, joinGroup, leaveGroup]);

// Refresh unread counts on socket reconnect so missed task_assigned / new_message
// events (while disconnected) are recovered from the DB.
useEffect(() => {
  if (connected) {
    loadUnreadCounts();
    loadPendingTaskCounts();
  }
}, [connected, loadUnreadCounts, loadPendingTaskCounts]);

  const toggleThread = (key) => {
    setExpandedThreads(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const filteredGroups = search
    ? groups.filter(g =>
        g.group_name?.toLowerCase().includes(search.toLowerCase()) ||
        g.campaign_name?.toLowerCase().includes(search.toLowerCase())
      )
    : null;

  const sortedGroups = filteredGroups || groups;

  // FIX 5: groupsToRender no longer does its own sort by last_message_at.
  // Sorting is handled entirely by getUnifiedSortedItems using stableSortTime.
  const groupsToRender = sortedGroups ? [...sortedGroups] : sortedGroups;

  const validThreads = threads.filter(thread => (thread.groups || []).length > 1);
  const threadGroupIds = new Set(validThreads.flatMap(t => t.groups.map(g => g.id)));

  // FIX 6: Unified sort — groups and threads treated identically.
  // Both use stableSortTime so:
  //   - New message → stablePositionRef stamped → item moves to top
  //   - Read message → stablePositionRef unchanged → item stays in place
  const getUnifiedSortedItems = useCallback(() => {
    if (search) {
      return groupsToRender.map(group => ({
        type: 'group',
        item: group,
        priority: 0,
        unreadCount: unreadCounts[group.id] || 0,
        lastMessageAt: new Date(group.last_message_at || 0),
        isPinned: isGroupPinned(group.id)
      }));
    }

    const allItems = [];

    // Pinned groups
    // const pinnedGroupItems = groups
    //   .filter(g => pinnedGroups.includes(g.id))
    //   .map(group => ({
    //     type: 'group',
    //     item: group,
    //     priority: 1,
    //     unreadCount: unreadCounts[group.id] || 0,
    //     lastMessageAt: new Date(group.last_message_at || 0),
    //     stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
    //     isPinned: true
    //   }));

  //   const pinnedGroupItems = pinnedGroups
  // .map(id => groups.find(g => g.id === id))
  // .filter(Boolean)
  // .map(group => ({
  //   type: 'group',
  //   item: group,
  //   priority: 1,
  //   unreadCount: unreadCounts[group.id] || 0,
  //   lastMessageAt: new Date(group.last_message_at || 0),
  //   stableSortTime:
  //   stablePositionRef.current[group.id] || 0,
  // // stablePositionRef.current[group.id] ??
  // // new Date(group.last_message_at || 0).getTime(),
  //   // stableSortTime: stablePositionRef.current[group.id] ?? 0,
  //   // stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
  //   isPinned: true
  // }));
// Pinned items
//old working
// const pinnedGroupItems = pinnedGroups
//   .map(id => groups.find(g => g.id === id))
//   .filter(Boolean)
//   .map(group => ({
//     type: 'group',
//     item: group,
//     priority: 1,
//     unreadCount: unreadCounts[group.id] || 0,
//     lastMessageAt: new Date(group.last_message_at || 0),
//     stableSortTime:
//       stablePositionRef.current[group.id] ||
//       new Date(group.created_at || group.last_message_at || 0).getTime(),
//     isPinned: true
//   }));

//new
// Pinned items — same change
const pinnedGroupItems = pinnedGroups
  .map(id => groups.find(g => g.id === id))
  .filter(Boolean)
  .map(group => ({
    type: 'group',
    item: group,
    priority: 1,
    unreadCount: unreadCounts[group.id] || 0,
    lastMessageAt: new Date(group.last_message_at || 0),
    stableSortTime: stablePositionRef.current[group.id] ||
      new Date(group.last_message_at || group.created_at || 0).getTime(),
    isPinned: true
  }));

    // Threads — same logic as groups, no priority difference
    const threadItems = threads
      .filter(thread => (thread.groups || []).length > 1)
      .map(thread => {
        const threadGroups = thread.groups || [];
        const totalUnreadCount = threadGroups.reduce((sum, group) =>
          sum + (unreadCounts[group.id] || 0), 0
        );
        const totalPendingTasks = threadGroups.reduce((sum, group) =>
          sum + (pendingTaskCounts[group.id] || 0), 0
        );
        const latestMessageAt = threadGroups.reduce((latest, group) => {
          const groupTime = new Date(group.last_message_at || 0);
          return groupTime > latest ? groupTime : latest;
        }, new Date(0));
        // Use the most recent stableSortTime across all groups in this thread
        const threadStableTime = threadGroups.reduce((latest, group) => {
          const t = stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime();
          return t > latest ? t : latest;
        }, 0);
        return {
          type: 'thread',
          item: thread,
          priority: 0,  // Same priority as groups — no bias
          unreadCount: totalUnreadCount,
          pendingTaskCount: totalPendingTasks,
          lastMessageAt: latestMessageAt,
          stableSortTime: threadStableTime,
          isPinned: false,
          groups: threadGroups
        };
      });

    // Unpinned groups not in threads
  //   const unpinnedGroupItems = groups
  //     .filter(g => !pinnedGroups.includes(g.id) && !threadGroupIds.has(g.id))
  //     .map(group => ({
  //       type: 'group',
  //       item: group,
  //       priority: 0,
  //       unreadCount: unreadCounts[group.id] || 0,
  //       lastMessageAt: new Date(group.last_message_at || 0),
  //       stableSortTime:
  //       stablePositionRef.current[group.id] || 0,
  // // stablePositionRef.current[group.id] ??
  // // new Date(group.last_message_at || 0).getTime(),
  //       // stableSortTime: stablePositionRef.current[group.id] ?? 0,
  //       // stableSortTime: stablePositionRef.current[group.id] || new Date(group.last_message_at || 0).getTime(),
  //       isPinned: false
  //     }));
// Unpinned items
//old working 
// const unpinnedGroupItems = groups
//   .filter(g => !pinnedGroups.includes(g.id) && !threadGroupIds.has(g.id))
//   .map(group => ({
//     type: 'group',
//     item: group,
//     priority: 0,
//     unreadCount: unreadCounts[group.id] || 0,
//     lastMessageAt: new Date(group.last_message_at || 0),
//     stableSortTime:
//       stablePositionRef.current[group.id] ||
//       new Date(group.created_at || group.last_message_at || 0).getTime(),
//     isPinned: false
//   }));
const unpinnedGroupItems = groups
  .filter(g => !pinnedGroups.includes(g.id) && !threadGroupIds.has(g.id))
  .map(group => ({
    type: 'group',
    item: group,
    priority: 0,
    unreadCount: unreadCounts[group.id] || 0,
    lastMessageAt: new Date(group.last_message_at || 0),
    // ✅ Always has a real value after seeding above
    stableSortTime: stablePositionRef.current[group.id] ||
      new Date(group.last_message_at || group.created_at || 0).getTime(),
    isPinned: false
  }));
//new
    allItems.push(...pinnedGroupItems, ...threadItems, ...unpinnedGroupItems);

    return allItems.sort((a, b) => {
      // 1. Pinned first
      if (a.isPinned && !b.isPinned) return -1;
      if (!a.isPinned && b.isPinned) return 1;

  // 2. If BOTH are pinned → KEEP ORIGINAL ORDER (do NOT sort)
  if (a.isPinned && b.isPinned) return 0;

      // 2. Unread before read
      // const aHasUnread = a.unreadCount > 0;
      // const bHasUnread = b.unreadCount > 0;
      // if (aHasUnread && !bHasUnread) return -1;
      // if (!aHasUnread && bHasUnread) return 1;

      // 3. stableSortTime — position freezes on read, moves only on new message
      return b.stableSortTime - a.stableSortTime;
    });
  }, [search, groupsToRender, groups, threads, pinnedGroups, unreadCounts, pendingTaskCounts, threadGroupIds, isGroupPinned]);

  const renderUnifiedItem = (itemData) => {
    const { type, item, unreadCount, pendingTaskCount = 0 } = itemData;

    if (type === 'thread') {
      const threadName = (() => {
        const firstGroup = item.groups?.[0];
        if (firstGroup?.crm_campaign_data) {
          try {
            const crmData = typeof firstGroup.crm_campaign_data === 'string'
              ? JSON.parse(firstGroup.crm_campaign_data)
              : firstGroup.crm_campaign_data;
            if (crmData?.campaign_name) return crmData.campaign_name;
          } catch {}
        }
        return item.package_id.replace(/^com\./, '');
      })();

      return (
        <div key={item.package_id}>
          <div
            className="group-item"
            onClick={() => toggleThread(item.package_id)}
            style={{ cursor: 'pointer', background: 'var(--bg-secondary)' }}
          >
            <div
              className="group-avatar"
              style={{
                background: `${avatarColor(threadName)}22`,
                color: avatarColor(threadName),
                border: `1px solid ${avatarColor(threadName)}44`
              }}
            >
              {getInitials(threadName)}
            </div>
            <div className="group-info">
              <div className="group-name">{threadName}</div>
              <div className="group-meta">
                <span>{item.groups.length} campaigns</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
              {unreadCount > 0 && (
                <span className="group-badge" style={{ background: 'var(--accent)' }}>
                  {unreadCount}
                </span>
              )}
              {pendingTaskCount > 0 && (
                <span className="group-badge" title="Open tasks assigned to you" style={{ background: '#f59e0b' }}>
                  📋 {pendingTaskCount}
                </span>
              )}
              <span style={{ fontSize: 12 }}>
                {expandedThreads[item.package_id] ? '▲' : '▼'}
              </span>
            </div>
          </div>
          {expandedThreads[item.package_id] && item.groups.map(group => renderGroup(group, true))}
        </div>
      );
    }

    return renderGroup(item, false);
  };

  const renderGroup = (group, isThreadGroup = false) => (
    <div
      key={group.id}
      className={`group-item ${selectedGroupId === group.id ? 'active' : ''}`}
      onClick={() => handleGroupSelect(group)}
    >
      <div
        className={`group-avatar ${group.group_type}`}
        style={{
          background: `${avatarColor(group.group_name)}22`,
          color: avatarColor(group.group_name),
          border: `1px solid ${avatarColor(group.group_name)}44`
        }}
      >
        {getInitials(group.group_name)}
      </div>
      <div className="group-info">
        <div className="group-name">{group.group_name}</div>
        <div className="group-meta">
          {draftGroupIds.has(group.id) && selectedGroupId !== group.id && (
            <span style={{ color: 'var(--accent)', fontWeight: 600, fontSize: 11, marginRight: 4 }}>✏️ Draft</span>
          )}
          {taskDraftGroupIds.has(group.id) && selectedGroupId !== group.id && (
            <span style={{ color: '#f59e0b', fontWeight: 600, fontSize: 11, marginRight: 4 }}>📋 Task</span>
          )}
          {group.campaign_status && (
            <span className={`badge badge-${group.campaign_status === 'active' ? 'live' : 'paused'}`} style={{ marginRight: 4 }}>
              {group.campaign_status}
            </span>
          )}
          {group.geo && <span>{group.geo.split(',')[0]} · </span>}
          {group.payout && <span>${group.payout}</span>}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
        <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>{formatTime(group.last_message_at)}</span>
        {(unreadCounts[group.id] || 0) > 0 && (
          <span className="group-badge" style={{ background: 'var(--accent)' }}>
            {unreadCounts[group.id]}
          </span>
        )}
        {(pendingTaskCounts[group.id] || 0) > 0 && (
          <span className="group-badge" title="Open tasks assigned to you" style={{ background: '#f59e0b' }}>
            📋 {pendingTaskCounts[group.id]}
          </span>
        )}
        <button
          className={`btn-icon ${isGroupPinned(group.id) ? 'pinned' : ''}`}
          onClick={(e) => { e.stopPropagation(); togglePinGroup(group.id); }}
          style={{
            fontSize: 10,
            padding: 2,
            opacity: isGroupPinned(group.id) ? 1 : 0.5,
            color: isGroupPinned(group.id) ? 'var(--warning)' : 'var(--text-muted)'
          }}
          title={isGroupPinned(group.id) ? 'Unpin group' : 'Pin group'}
        >
          📌
        </button>
      </div>
    </div>
  );

  return (
    <div className="sidebar">
      {/* <div style={{fontSize:10, background:'#111', color:'#0f0', padding:6}}>
  <div>UnreadCounts: {JSON.stringify(unreadCounts)}</div>
  <div>StableRef: {JSON.stringify(stablePositionRef.current)}</div>
</div> */}
      <div className="sidebar-header">
        <div className="sidebar-title">
          <span>💬</span>
          <span>CRM Chat</span>
          <span style={{ marginLeft: 4 }} className={`status-dot ${connected ? 'online' : 'offline'}`} />
        </div>
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <button className="btn-icon tooltip" onClick={toggleTheme} title={isDark ? 'Light mode' : 'Dark mode'}>
            <span style={{ fontSize: 15 }}>{isDark ? '🌙' : '🌞'}</span>
            <span className="tooltip-text">{isDark ? 'Light mode' : 'Dark mode'}</span>
          </button>
          {(user?.role === 'admin' || user?.role === 'advertiser_manager' || user?.role === 'advertiser' || user?.role === 'adv_executive') && (
            <button className="btn-icon tooltip" onClick={() => setShowCreateModal(true)} title="New Group">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              <span className="tooltip-text">New Group</span>
            </button>
          )}
          <button className="btn-icon tooltip" onClick={logout}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
            </svg>
            <span className="tooltip-text">Logout</span>
          </button>
        </div>
      </div>

      <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: `${avatarColor(user?.full_name)}33`, color: avatarColor(user?.full_name), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>
          {getInitials(user?.full_name)}
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600 }}>{user?.full_name}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role}</div>
        </div>
        <span className="status-dot online" style={{ marginLeft: 'auto' }} />
      </div>

      <div className="sidebar-search">
        <input
          type="text"
          className="search-input"
          placeholder="Search groups..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="sidebar-groups">
        {loading ? (
          <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>Loading groups...</div>
        ) : (
          <>
            {getUnifiedSortedItems().length > 0 ? (
              getUnifiedSortedItems().map(renderUnifiedItem)
            ) : (
              <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>
                {search ? 'No results' : 'No groups yet. Create one from a campaign.'}
              </div>
            )}
            {!loading && groups.length === 0 && !search && (
              <div className="empty-state" style={{ padding: 40 }}>
                <div className="empty-state-icon">🗂️</div>
                <p>No groups yet.<br/>Create one from a campaign.</p>
                {(user?.role === 'admin' || user?.role === 'advertiser_manager' || user?.role === 'advertiser' || user?.role === 'adv_executive' ) && (
                  <button className="btn btn-primary btn-sm" onClick={() => setShowCreateModal(true)}>
                    Create Group
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {showCreateModal && (
        <CreateGroupModal
          onClose={() => setShowCreateModal(false)}
          onCreated={(group) => {
            loadGroups();
            setShowCreateModal(false);
            onSelectGroup(group);
            toast.success('Group created!');
          }}
        />
      )}
      
    </div>
  );
}
